import './index.scss'

interface ISectionTitle {
  title: string
  rightRender?: React.ReactNode
}

export const SectionTitle = ({ title, rightRender }: ISectionTitle) => {
  return (
    <div className="section-title">
      {title}
      {rightRender && <div className="right">{rightRender}</div>}
    </div>
  )
}
